var map = {
	"./authority-form-values/authority-form-values.en.json": "./src/app/shared/pipes/json/form-values/authority-form-values/authority-form-values.en.json",
	"./authority-form-values/authority-form-values.it.json": "./src/app/shared/pipes/json/form-values/authority-form-values/authority-form-values.it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/shared/pipes/json/form-values sync recursive ^\\.\\/.*\\.json$";